import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { loginWithGoogle, loginWithEmail, registerWithEmail } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleGoogle() {
    setError(""); setLoading(true);
    try {
      await loginWithGoogle();
      navigate("/feed");
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      if (mode === "login") {
        await loginWithEmail(email, password);
      } else {
        await registerWithEmail(email, password, displayName);
      }
      navigate("/feed");
    } catch (e) {
      setError(e.message.replace("Firebase: ", "").replace(/\(auth.*\)/, "").trim());
    }
    setLoading(false);
  }

  return (
    <div className="main" style={{ maxWidth: 400 }}>
      <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
        <div style={{ fontFamily: "var(--serif)", fontStyle: "italic", fontWeight: 300, fontSize: 36, marginBottom: 8 }}>builtday</div>
        <p style={{ color: "var(--text-muted)", fontSize: 14 }}>Document your project journey, day by day.</p>
      </div>

      <div className="card">
        <div className="tabs" style={{ marginBottom: "1.25rem" }}>
          <button className={`tab ${mode === "login" ? "active" : ""}`} onClick={() => setMode("login")}>sign in</button>
          <button className={`tab ${mode === "register" ? "active" : ""}`} onClick={() => setMode("register")}>create account</button>
        </div>

        {error && <div className="msg-error">{error}</div>}

        <button onClick={handleGoogle} className="btn" style={{ width: "100%", justifyContent: "center", marginBottom: "1rem" }} disabled={loading}>
          <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
          Continue with Google
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "0 0 1rem", color: "var(--text-faint)", fontSize: 12 }}>
          <div style={{ flex: 1, height: "0.5px", background: "var(--border)" }} />
          or
          <div style={{ flex: 1, height: "0.5px", background: "var(--border)" }} />
        </div>

        <form onSubmit={handleSubmit}>
          {mode === "register" && (
            <div className="form-group">
              <label className="form-label">display name</label>
              <input className="form-input" type="text" value={displayName} onChange={e => setDisplayName(e.target.value)} required placeholder="Your name" />
            </div>
          )}
          <div className="form-group">
            <label className="form-label">email</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="you@example.com" />
          </div>
          <div className="form-group">
            <label className="form-label">password</label>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••" minLength={6} />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }} disabled={loading}>
            {loading ? "…" : mode === "login" ? "sign in" : "create account"}
          </button>
        </form>
      </div>

      <p style={{ textAlign: "center", fontSize: 13, color: "var(--text-faint)", marginTop: "1.5rem", fontStyle: "italic", fontFamily: "var(--serif)" }}>
        Shipping is content. Struggle is content. Progress is content.
      </p>
    </div>
  );
}
